<template>
  <el-button :type="type" :size="size" @click="downloadFile">
    <slot></slot>
  </el-button>
</template>

<script>
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
  name: 'FileLink',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    size: {
      type: String,
      default: 'mini'
    },
    fileUrl: {
      type: String,
      required: true
    },
    fileType: {//下载类型,如果是前端文件，则为front，如果是后端文件，则为back
      type: String,
      required: true,
      default: 'front'
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    async downloadFile () {
      if (this.fileType === 'front') {
        // 发送http请求，将文件链接转换成文件流
        this.fileAjax(this.fileUrl, xhr => {
          this.downFromFront(xhr.response, this.fileUrl.split('/').pop())
        }, {
          responseType: 'blob'
        })
      } else if (this.fileType === 'back') {
        let loading = this.$loading()
        try {
          await this.downFromBack()
        } catch (e) {
          console.log('downloadFile', e)
        } finally {
          loading.close()
        }
      }
    },
    fileAjax (url, callback, options) {
      let xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
    downFromFront (content, filename) {
      window.URL = window.URL || window.webkitURL
      let a = document.createElement('a')
      let blob = new Blob([content])
// 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
// 销毁创建的url
      window.URL.revokeObjectURL(url)
    },
    async startDownload (filePath, fileName) {
      let fileBlob = await this.$api2.get(`/base/file/download?fileName=${filePath}`, { responseType: 'blob' })
      try {
        let url = window.URL.createObjectURL(new Blob([fileBlob]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        console.log('downFromBack', e)
      }
    },
    async downFromBack () {
      let fileInfo = await this.$api2.post(this.fileUrl, this.params)
      console.log('fileInfo', fileInfo)
      this.startDownload(fileInfo.filePath, fileInfo.fileName)
    }
  },
}
</script>

<style scoped>

</style>
